import type React from 'react'

export const GaLogo: React.FC = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="18" y="44" width="12" height="18" rx="4" fill="#2F7FEF" />
      <rect x="34" y="32" width="12" height="30" rx="4" fill="#2F7FEF" />
      <rect
        x="50"
        y="18"
        width="12"
        height="44"
        rx="4"
        fill="#2F7FEF"
        opacity="0.55"
      />
    </svg>
  )
}
